import { render, staticRenderFns } from "./voipManagement.vue?vue&type=template&id=19077610&scoped=true&"
import script from "./voipManagement.vue?vue&type=script&lang=ts&"
export * from "./voipManagement.vue?vue&type=script&lang=ts&"
import style0 from "./voipManagement.vue?vue&type=style&index=0&id=19077610&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19077610",
  null
  
)

export default component.exports